import { render, staticRenderFns } from "./CardListBuilder.vue?vue&type=template&id=036c9126&scoped=true&"
import script from "./CardListBuilder.vue?vue&type=script&lang=js&"
export * from "./CardListBuilder.vue?vue&type=script&lang=js&"
import style0 from "./CardListBuilder.vue?vue&type=style&index=0&id=036c9126&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036c9126",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('036c9126')) {
      api.createRecord('036c9126', component.options)
    } else {
      api.reload('036c9126', component.options)
    }
    module.hot.accept("./CardListBuilder.vue?vue&type=template&id=036c9126&scoped=true&", function () {
      api.rerender('036c9126', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CardListBuilder.vue"
export default component.exports